import React, { useContext } from 'react';
import { useStandings } from '../hooks/standings';
import { useTeamLogos } from '../hooks/team';
import StandingsRow from '../components/Standings/StandingsRow';
import { DataContext } from '../context/data-context';
import { filterStandings } from '../utils/functionalUtils';

export default function StandingsTableBody() {
  const { currentSeason } = useContext(DataContext);
  const [data, loading] = useStandings(currentSeason);
  const [teamLogos, loadingTeamLogos] = useTeamLogos();
  if (!data || !teamLogos || loading || loadingTeamLogos) return null;
  const standings = filterStandings(data);
  const getTeamLogo = (abbrv) => {
    const team = teamLogos?.find((x) => x.abbrv === abbrv);

    return (
      team?.logo ||
      team?.logoImageUrl ||
      '/wp-content/themes/sef-leagues/images/generic-team.png'
    );
  };

  return standings?.map((item) => (
    <StandingsRow
      data={item}
      key={item.id}
      logo={getTeamLogo(item.teamAbbrv)}
    />
  ));
}
